import { render, staticRenderFns } from "./comercial_multimedia.vue?vue&type=template&id=15fd82fa&"
import script from "./comercial_multimedia.vue?vue&type=script&lang=js&"
export * from "./comercial_multimedia.vue?vue&type=script&lang=js&"
import style0 from "./comercial_multimedia.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('15fd82fa', component.options)
    } else {
      api.reload('15fd82fa', component.options)
    }
    module.hot.accept("./comercial_multimedia.vue?vue&type=template&id=15fd82fa&", function () {
      api.rerender('15fd82fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Map/Details/comercial_multimedia.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/Map/Details/comercial_multimedia.vue
// module id = Tprj
// module chunks = 0